import { useEffect, useMemo, useState } from 'react';

export const HEALTH_INSIGHTS_FILTERS_STORAGE_KEY = 'healthInsightsFilters';
export const CATEGORY_FILTERS_STORAGE_KEY = 'categoryFilters';

export const useCategoryMetricsV2Filters = ({
  allCategories,
  allHealthInsights,
}: {
  allCategories: string[];
  allHealthInsights: string[];
}) => {
  const [healthInsightsFilters, setHealthInsightsFilters] = useState<string[]>(
    () => {
      const stored = sessionStorage.getItem(HEALTH_INSIGHTS_FILTERS_STORAGE_KEY);
      return stored ? JSON.parse(stored) : allHealthInsights;
    },
  );

  const [categoryFilters, setCategoryFilters] = useState<string[]>(() => {
    const stored = sessionStorage.getItem(CATEGORY_FILTERS_STORAGE_KEY);
    return stored ? JSON.parse(stored) : allCategories;
  });

  useEffect(() => {
    sessionStorage.setItem(
      HEALTH_INSIGHTS_FILTERS_STORAGE_KEY,
      JSON.stringify(healthInsightsFilters),
    );
  }, [healthInsightsFilters]);

  useEffect(() => {
    sessionStorage.setItem(
      CATEGORY_FILTERS_STORAGE_KEY,
      JSON.stringify(categoryFilters),
    );
  }, [categoryFilters]);

  useEffect(() => {
    if (allCategories.length > 0 && categoryFilters.length === 0) {
      const stored = sessionStorage.getItem(CATEGORY_FILTERS_STORAGE_KEY);
      if (!stored) {
        setCategoryFilters(allCategories);
      }
    }
  }, [allCategories, categoryFilters.length]);

  const handleFiltersChange = useMemo(
    () => (healthInsights: string[], categories: string[]) => {
      setHealthInsightsFilters(healthInsights);
      setCategoryFilters(categories);
    },
    [],
  );

  return {
    healthInsightsFilters,
    categoryFilters,
    handleFiltersChange,
  };
};
